import React from "react";

export function ArrowRightIcon(props) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.6875 12.7188C19.0938 12.3438 19.0938 11.6875 18.6875 11.3125L13.6875 6.3125C13.3125 5.90625 12.6562 5.90625 12.2812 6.3125C11.875 6.6875 11.875 7.34375 12.2812 7.71875L15.5625 11H6C5.4375 11 5 11.4688 5 12C5 12.5625 5.4375 13 6 13H15.5625L12.2812 16.3125C11.875 16.6875 11.875 17.3438 12.2812 17.7188C12.6562 18.125 13.3125 18.125 13.6875 17.7188L18.6875 12.7188Z"
      />
    </svg>
  );
}
